<template>
    <div>
        <a-modal :destroyOnClose="true" :visible="visible" width="1000px" :closable="false" okText="确定" cancelText="取消"
            centered :confirmLoading="btnLoading" @ok="save" @cancel="visible = false" title="商品规格添加">
            <div style="overflow-y: scroll;height: 400px">
                <a-form layout="inline" :form="form" style="margin-bottom: 15px">
                    <a-row style="display: flex;flex-direction: row">
                        <div v-if="rule">
                            <span style="margin-right: 10px">规则名称：</span>
                            <div style="margin:20px 0;" v-for="(item, index) in ruledata" :key="index">
                                <a-input placeholder="填写规格名称" v-model="item.rule_name" style="width: 150px;height: 40px;margin-right: 10px">
                                        <!-- <a-icon slot="suffix" type="close-circle" @click="deletrule(index)" v-if="item.rule_name != ''" /> -->
                                </a-input>
                                <a-button class="editable-add-btn" @click="saveInput(item)">保存</a-button>
                                <a-button class="editable-add-btn" @click="deletrule(item)">删除</a-button>
                            </div>
                        </div>
                        <a-button type="dashed" icon="plus" @click="addRule"
                            style="width: 150px;height: 40px;margin-top: 40px;margin-left: 10px;">添加新规则</a-button>
                    </a-row>
                    <a-row v-for="(item, index) in k_ruledata" :key="index"
                        style="display: flex;flex-direction: row;margin-top: 20px;align-items: center;">
                        <div style="float:left;display: flex;flex-direction: row">
                            <span style="margin-right: 10px;margin-top: 5px">{{ item.k_rule_name }}:</span>
                            <div v-if="item.k_rule" v-for="(itemto, indexto) in item.k_moreruledata" :key="indexto" style="margin-right: 10px;width: 80px;height: 30px;
                                    display: flex;flex-direction: row;
                                    color:#578CE5 ;
                                    border-radius: 4px;border: 1px solid #578CE5">
                                <div style="flex: 2;border-right: 1px solid #578CE5;text-align: center;line-height: 30px ">
                                    {{ itemto.rule_name }}
                                </div>
                                <div style="flex: 1;text-align: center;line-height: 30px" @click="deleteBtn(index,indexto)">
                                    X
                                </div>
                            </div>
                        </div>
                        <a-input placeholder="设置属性" v-model="item.provaluse"
                            style="width: 150px;height: 30px;margin-right: 10px" />
                        <a-button type="primary" @click="k_addpro(item)" style="width: 60px;height: 30px">添加
                        </a-button>
                    </a-row>
                    <a-button type="primary" style="margin-top: 20px;width: 600px" @click="autodata">生成</a-button>

                    <!--自动生成的数据列表-->
                    <div v-if="autodata_rule">
                        <a-table :dataSource="autoruledata" :columns="columnsList" :pagination="false">
                            <!-- <template v-for="(col, i) in ['goods_photo']" :slot="col" slot-scope="text, record">
                                <div class="clearfix">
                                    <a-upload :key="col" :maxCount="1" list-type="picture-card" @change="handleChangess" >
                                        <img  alt="上传图片" style="width: 100%" :src="text.goods_photo" />
                                    </a-upload>



                                    <a-upload
                                    :key="col"
                                    v-model="autoruledata[i].goods_photo"
                                    @change="handleChangess"
                                    list-type="picture-card"
                                    >
                                    
                                    <div v-if="autoruledata[i].goods_photo">
                                        <div style="margin-top: 8px">上传图片</div>
                                    </div>
                                    </a-upload>
                                    <img alt="example" style="width: 100%" :src="col.goods_photo" />
                                </div>
                            </template> -->
                        </a-table>
                    </div>
                </a-form>
            </div>
        </a-modal>
        <!-- <a-icon type="plus" style="font-size:20px;color:#3E86ED;margin-left: 10px" @click="toadd">添加商品规格</a-icon> -->
        <a-button class="editable-add-btn" @click="toadd">添加商品规格</a-button>

    </div>
</template>
 
<script>
function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
}
import Home from '../../api/Home'
export default {
    props: {

        ugro_id: {//订单ID
            type: Number,
            default: 0
        },
    },
    name: "",
    data() {
        return {
            visible: false,
            btnLoading: false,
            form: this.$form.createForm(this),
            rule: false,//规格
            ruledata: [],
            k_ruledata: [],//一个规格--》对应 多个属性
            autodata_rule: false,
            autoruledata: [],//自动生成的数据
            zum: [],

            total:0,//总数
            visibleedit:false,
            dataSourceList: [],
            columnsList: [{
                title: '套餐名称',
                dataIndex: 'rule_name',
                width: '10%',
            },{
                title: '市场价',
                width: '10%',
                customRender: (v) => {
                    return (
                        <a-input v-model={v.goods_cost_marketprice} placeholder="请输入市场价" />
                    )
                }
            }, {
                title: '销售价',
                width: '10%',
                customRender: (v) => {
                    return (
                        <a-input v-model={v.goods_cost_salePrice} placeholder="请输入销售价" />
                    )
                }
            }, {
                title: '库存',
                width: '10%',
                customRender: (v) => {
                    return (
                        <a-input v-model={v.goods_cost_inventory} placeholder="请输入库存" />
                    )
                }
            },
            {
                title: '图片',
                width: '10%',
                key: 'goods_photo',
                // scopedSlots: { customRender: 'goods_photo' },
                customRender: (v,i)=> {
                    if(v.goods_photo){
                        return(
                            <img  style="width: 100px;height:100px" onClick={(v,i)=>{deletegoodsImg(v,i)}} src={v.goods_photo} />
                        )
                    }else{
                        return (
                            <a-upload  list-type="picture-card" onChange={(v)=>{this.handleChangess(v,i)}} >
                                <img  alt="上传图片" style="width: 100%" src={v.goods_photo} />
                            </a-upload>
                        )
                    }
                   
                }
            }
        ],
            newImg:[]
        }
    },
    mounted() {
                          
        
    },

    methods: {
        deletegoodsImg(v,i){
            console.log(v,i)
        },
        async handleChangess(e,index){
            let files = await getBase64(e.file.originFileObj)
            this.autoruledata.forEach((item,i)=>{
                if (item.rule_name.indexOf(index.rule_name) != -1) {
                    Home.upload({ img: files }).then(res => {
                        if (res.status == 1) {
                            this.autoruledata[i]['goods_photo'] = res.result;
                        }
                    })
                }
            })
           
        },
        deleteBtn(v,i){
            this.k_ruledata[v].k_moreruledata.splice(i,1)
        },
        toadd() {//添加规格
            this.visible = true;
            this.rule = false;
            this.autodata_rule = false;
            this.ruledata = [];//暂时
            this.k_ruledata = [];
            this.autoruledata = [];
            this.zum = [];
        },

        //添加规则
        addRule() {
            //添加一个数据
            let ss = { rule_id: '', rule_name: '' };
            this.ruledata.push(ss);
            this.rule = true;
        },

        //删除规则
        deletrule(index) {
            this.$confirm({
                content: "确认删除这个规则名称?",
                okText: "确定",
                title: "提示",
                okType: "danger",
                centered: true,
                cancelText: "取消",
                onOk: () => {
                    this.ruledata.splice(index, 1);
                    //对应删除--相应的属性
                    this.k_ruledata.splice(index, 1);
                }
            });


        },
        saveInput(item) {
            try {
                this.k_ruledata.forEach((i) => {
                    if (i.k_rule_name == item.rule_name) {
                        throw '请勿重复填写';
                    }
                })
            } catch (e) {
                this.$message.error(e);
            }
            let ss = {
                k_rule_id: item.rule_id,
                k_rule_name: item.rule_name,
                k_rule: false,
                k_provaluse: '',//属性
                k_moreruledata: [],
            }
            this.k_ruledata.push(ss);
        },
        k_addpro(item) {//添加属性
            let ss = { rule_id: '', rule_name: item.provaluse };
            item.k_moreruledata.push(ss);
            item.k_rule = true;
            //添加完成后
            item.provaluse = "";
        },
        autodata() {//自动生成
            // //autoruledata
            if (this.k_ruledata.length < 0) {
                this.$message.info('请先添加');
                return;
            }
            this.zum = [];
            for (let index in this.k_ruledata) {//循环的次数
                this.getDate(this.zum, this.k_ruledata[index]);
            }
            
            for (let index in this.zum) {
                this.zum[index].rule_id = "";
                this.zum[index].goods_cost_marketprice = '';//市场价
                this.zum[index].goods_cost_salePrice = '';//销售价
                this.zum[index].goods_cost_inventory = '';//库存
                this.zum[index].goods_photo = '';//图片
            }
            this.autoruledata = JSON.parse(JSON.stringify(this.zum)) 
            // this.autoruledata = this.zum;


            this.autodata_rule = true;
        },
        getDate(zum, first) {//公共存的集合  第一个集合
            if (zum.length != 0) {
                let item = first.k_moreruledata;
                let zumto = [];
                for (let index in zum) {
                    for (let to in item) {
                        let ss = {};
                        ss.rule_name = zum[index].rule_name + "/" + first.k_rule_name + ":" + item[to].rule_name;
                        zumto.push(ss);
                    }
                }
                this.zum = zumto;
            } else {
                let item = first.k_moreruledata;
                for (let index in item) {
                    let ss = {};
                    ss.rule_name = first.k_rule_name + ":" + item[index].rule_name;
                    zum.push(ss);
                }
                this.zum = zum;

            }
        },
        save() {
            console.log('this.autoruledata-save:',this.autoruledata);

            // let arr = [];
            // this.autoruledata.forEach((v,n)=>{
                // arr.push({
                //     name:v.rule_name || 0,
                //     goods_cost_marketprice:v.goods_cost_marketprice || 0,
                //     goods_cost_salePrice:v.goods_cost_salePrice || 0,
                //     goods_cost_inventory:v.goods_cost_inventory || 0,
                // })
            // })
            // console.log('saveArr:',arr)
            // this.setData(arr)
        },
    }

}
</script>
 
<style lang="scss" scoped></style>